import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  Box, Button, Card, CardContent, Typography,
} from '@mui/material';
import { VARIANTS } from 'shared/constants';

/**
 * The router's fallback. Routes the account lacks permission for aren't registered, so they
 * land here too; the copy covers both.
 */
export default function NotFound() {
  const { pathname } = useLocation();

  return (
    <Box sx={{ maxWidth: 560, mx: 'auto', mt: 6 }}>
      <Card>
        <CardContent sx={{ p: 4 }}>
          <Typography variant="h5" component="h1" gutterBottom>
            Page not found
          </Typography>
          <Typography sx={{ color: 'text.secondary', mb: 2.5 }}>
            Nothing is at
            {' '}
            <code>{pathname}</code>
            . The link may be out of date, or your account
            may not have access to this page.
          </Typography>
          <Button variant={VARIANTS.contained} component={Link} to="/">
            Go to Home
          </Button>
        </CardContent>
      </Card>
    </Box>
  );
}
